import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  OnDestroy,
  TemplateRef
} from '@angular/core';
import { WindowRef } from '../window-ref/window-ref.service';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 're-infinite-scroll',
  template: "\n    <ng-template #defaultTemplate let-spinner=\"\"><div class=\"spinner\"><div class=\"bounce bounce1\"></div><div class=\"bounce bounce2\"></div><div class=\"bounce bounce3\"></div></div></ng-template><ng-template [ngTemplateOutlet]=\"spinnerTemplate || defaultTemplate\" [ngTemplateOutletContext]=\"{ $implicit: this }\"></ng-template>\n  ",
  styles: ["\n    .spinner{margin:10px auto 0;width:150px;text-align:center}.spinner .bounce{width:24px;height:24px;background-color:#e3c381;border-radius:100%;display:inline-block;-webkit-animation:bouncedelay 1.4s infinite ease-in-out;animation:bouncedelay 1.4s infinite ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.spinner .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.spinner .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes bouncedelay{0%,100%,80%{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes bouncedelay{0%,100%,80%{transform:scale(0);-webkit-transform:scale(0)}40%{transform:scale(1);-webkit-transform:scale(1)}}\n  "],
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'infiniteScroll'
})
export class InfiniteScrollComponent implements OnInit, OnDestroy {

  @Input() total: number;
  @Input() bufferPx = 40;
  @Input() scrollDelay = 300;
  @Input() spinnerTemplate: TemplateRef<any>;
  @Output() loadMore = new EventEmitter<InfiniteScrollComponent>();
  scrollStream = new EventEmitter<any>();
  subscription: Subscription;

  constructor(private windowRef: WindowRef, private elementRef: ElementRef) {

  }

  ngOnInit(): void {
    this.setupScrollEvent();
    setTimeout(_ => this.onWinScroll(null));
  }

  loadFinish(complete: boolean) {
    if (complete) {
      return this.unSubscription();
    }

    setTimeout(_ => this.onWinScroll(null), this.scrollDelay);
  }

  private setupScrollEvent() {
    if (!this.subscription) {
      this.subscription = this.registerOnScrollStream(this.scrollStream)
        .subscribe(_ => this.onScrollChange());
    }
  }

  onScrollChange() {
    const winHeight = this.windowRef.innerHeight;
    const clientRect = this.windowRef.getBoundingClientRect(this.elementRef);
    if (clientRect && winHeight - clientRect.top >= this.bufferPx) {
      this.loadMore.emit(this);
    }

  }

  @HostListener('window:scroll', ['$event'])
  onWinScroll($event: Event) {
    this.scrollStream.emit($event);
  }

  ngOnDestroy(): void {
    this.unSubscription();
  }

  private unSubscription() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  private registerOnScrollStream(scrollStream: EventEmitter<UIEvent>) {
    return scrollStream.pipe(
      debounceTime(this.scrollDelay),
      distinctUntilChanged()
    );
  }
}
